import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../services/formulario-validaciones-docs.service';

@Component({
  selector: 'app-configuracion-documento-firmante',
  templateUrl: './configuracion-documento-firmante.component.html',
  styleUrls: ['./configuracion-documento-firmante.component.css']
})
export class ConfiguracionDocumentoFirmanteComponent implements OnInit, OnDestroy {

  @Input() esDocumentoEnEdicion = false;

  private genericoSubscription?: Subscription;
  private genericoAnterior: boolean | null = null;
  private aplicandoCambioGenerico = false;

  constructor(public formularioDocumentoService: FormularioDocumentoService,
              public formularioValidacionesDocsService: FormularioValidacionesDocsService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    const genericoControl = this.formularioDocumentoService.formularioDocumento.get('generico');
    this.genericoAnterior = genericoControl?.value ?? null;
    this.genericoSubscription = genericoControl?.valueChanges.subscribe((value) => {
      this.onGenericoChanged(genericoControl, value);
    });
  }

  ngOnDestroy(): void {
    this.genericoSubscription?.unsubscribe();
  }

  private onGenericoChanged(genericoControl: AbstractControl | null, value: boolean | null): void {
    if (this.aplicandoCambioGenerico || value === this.genericoAnterior) {
      return;
    }

    const aplicarCambio = () => {
      this.aplicandoCambioGenerico = true;
      this.formularioDocumentoService.limpiarDatosPorCambioGenerico(this.esDocumentoEnEdicion);
      this.genericoAnterior = value;
      this.aplicandoCambioGenerico = false;
    };

    if (this.esDocumentoEnEdicion) {
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-save2',
          titulo: '¿Cambiar la forma de identificar firmantes?',
          mensaje: 'Si cambia la forma de identificar los firmantes se perderán los datos asociados: identificación NIF, firmas, formularios y campos editables configurados.',
          textoConfirmacion: 'continuar',
          iconoConfirmacion: 'icon-tick',
          textoCancelar: 'cancelar',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'OK') {
          aplicarCambio();
        } else {
          this.aplicandoCambioGenerico = true;
          genericoControl?.setValue(this.genericoAnterior, { emitEvent: false });
          this.aplicandoCambioGenerico = false;
        }
      });
      return;
    }

    aplicarCambio();
  }

}
